import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private http: HttpClient) { }

  AddContact(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/contact/add`, params);
  }
}
